import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';



@Component({
    selector: 'microapp-faultreport-resolve-fault-component',
    templateUrl: './microapp-faultreport.component-resolve-fault.component.html',
    styleUrls: ['./microapp-faultreport.component-resolve-fault.component.css']
  })
  export class ResolveDialog{
    comment:string;
    
      constructor(public dialogRef:MatDialogRef<ResolveDialog>,
         private translate: TranslateService){}
  
        onNoClick():void{
          this.dialogRef.close();
        }
  
  }
  